import * as jsxRuntime from "/home/vsts/work/1/s/src/VetAmerikan.UI.Web/ClientApp/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment